var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "py-80 px-40" },
    [
      _c(
        "el-form",
        {
          attrs: {
            "button-class": "btn btn-green btn-rounded w-full font-bold",
            "submit-text": _vm.translations.post_review
          }
        },
        [
          _c("h2", { staticClass: "h5 mb-16" }, [
            _vm._v(_vm._s(_vm.translations.write_a_review))
          ]),
          _vm._v(" "),
          _c("score-stars", {
            staticClass: "mb-40",
            attrs: { score: 5, large: true, input: true },
            on: { "score-stars-input": _vm.setScore }
          }),
          _vm._v(" "),
          _c("el-input", {
            staticClass: "mb-16",
            attrs: { rules: "required", label: _vm.translations.title_label },
            model: {
              value: _vm.newReview.title,
              callback: function($$v) {
                _vm.$set(_vm.newReview, "title", $$v)
              },
              expression: "newReview.title"
            }
          }),
          _vm._v(" "),
          _c("el-input", {
            staticClass: "mb-16",
            attrs: {
              rules: "required",
              label: _vm.translations.description,
              type: "textarea"
            },
            model: {
              value: _vm.newReview.text,
              callback: function($$v) {
                _vm.$set(_vm.newReview, "text", $$v)
              },
              expression: "newReview.text"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }